import {Component} from 'react';

class ShippingPriceComponent extends Component {

    render() {
        return ''
    }
}
export default ShippingPriceComponent;
